import DictSelectTag from '@/components/dict/DictSelectTag.vue';
import MultiSelectTag from '@/components/dict/MultiSelectTag.vue';
import SearchSelectTag from '@/components/dict/SearchSelectTag.vue';
import { filterMultiDictText,filterDictText,initDictOptions,filterDictTextByCache } from '@/components/dict/dict-select-utils';


export default {
    install: function (Vue) {
        Vue.component('DictSelectTag',DictSelectTag);
        Vue.component('MultiSelectTag',MultiSelectTag);
        Vue.component('SearchSelectTag',SearchSelectTag);
        Vue.prototype.$initDictOptions = (dictCode) => initDictOptions(dictCode)
        Vue.prototype.$filterMultiDictText = (dictOptions, text) => filterMultiDictText(dictOptions, text)
        Vue.prototype.$filterDictText = (dictOptions, text) => filterDictText(dictOptions, text)
        Vue.prototype.$filterDictTextByCache = (...param) => filterDictTextByCache(...param)
    }
}



